import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardHeader, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid";
import columns from "./columns";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getDrawingOfficeWorkPackageStatuses } from "../actions";

function mapStateToProps(state) {
  return {
    drawing_office_work_package_statuses: state.drawing_office_work_package_statuses,
  };
}

const DrawingOfficeWorkPackageStatusesIndex = (props) => {
  useEffect(() => {
    props.getDrawingOfficeWorkPackageStatuses();
  }, []);

  const { drawing_office_work_package_statuses } = props;

  const readRole = HasRole({ resource_type: "DrawingOffice::WorkPackageStatus", name: ["read", "moderator"] });
  const createRole = HasRole({ resource_type: "DrawingOffice::WorkPackageStatus", name: ["create", "moderator"] });
  const updateRole = HasRole({ resource_type: "DrawingOffice::WorkPackageStatus", name: ["update", "moderator"] });

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardHeader>
          <Row>
            <Col>
              <h3>Work package statuses</h3>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          {createRole && (
            <Row>
              <Col>
                <Link to={`/drawing_office/work_package_statuses/new`}>
                  <Button color="primary" size="md">
                    <i className="fa fa-plus"> Create New Work package status</i>
                  </Button>
                </Link>
              </Col>
            </Row>
          )}

          <Row className="mt-2">
            <Col>
              <DefaultDataGrid columns={columns(updateRole)} data={drawing_office_work_package_statuses} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
};
export default connect(mapStateToProps, { getDrawingOfficeWorkPackageStatuses })(DrawingOfficeWorkPackageStatusesIndex);
